'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var Border = require('../common/Border');
var i18n = require('../../helper/i18n');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');
var LinkHelper = require('../common/LinkHelper');
var graphicsHelper = require('./../../helper/graphicsHelper');

var Node = React.createClass({
  render: function () {
    return (
      <Border key="border" {...{
        borderWidth: 1,
        borderColor: '#444',
        borderVisible: true,
        color: '#fff',
        partStyle: {
          width: this.props.rect.right - this.props.rect.left,
          height: this.props.rect.bottom - this.props.rect.top,
          left: this.props.rect.left,
          top: this.props.rect.top,
          textAlign: 'center',
          textDecoration: 'inherit',
          whiteSpace: 'pre',
          position: 'absolute'
        }
      }}>
        <p ref="text">{this.props.text}</p>
      </Border>
    );
  },

  componentDidMount: function () {
    var p = ReactDOM.findDOMNode(this.refs.text);
    $(p).css({'margin-top': (this.props.rect.height - p.clientHeight) / 2 - 2,padding:0})
  }
});

var SiteMap = React.createClass({
  parseTreeNode: function (node, nodes, leave) {
    var i = 0;
    if (!leave) {
      node = nodes[0];
      leave = 1;
    }
    if (nodes.length) {
      node.children = [];
      i = node.index + 1;
      for (i; i < nodes.length; i++) {
        //查找下一级子节点
        if (nodes[i].leave === leave + 1) {
          node.children.push(nodes[i]);
        }
        //如果碰到与自己平级或高级的节点，结束当前循环
        else if(nodes[i].leave <= leave){
          break;
        }
      }
    }
    if (node.children && node.children.length) {
      i = 0;
      for (i; i < node.children.length; i++) {
        this.parseTreeNode(node.children[i], nodes, node.children[i].leave);
      }
    } else {
      delete node.children;
    }
    return node;
  },

  parseToNodes: function () {
    var nodes = [];
    var textArr = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);
    var item;
    var leave;
    var links = LinkHelper.tranItemRect(this.props.itemRect) || this.props.links.link;
    try {
      textArr.map(function (text, index) {
        leave = 1;
        item = {};
        while (text.charAt(0) === '-') {
          leave ++;
          text = text.substring(1);
        }
        text = util.Text.convertSpaceToNbsp(text);
        item.text = text.trim().replace(/\\r/g, '\n');
        item.leave = leave;
        item.index = index;
        item.rect = links[index].area ? links[index].area.coords : links[index];
        util.Rect.init(item.rect);
        nodes.push(item);
      }, this);
    } catch (e) {
      this.isError = true;
    }
    return nodes;
  },


  render: function () {
    var nodes = this.parseToNodes();
    var _nodes = nodes.slice();
    var errorText;
    var errorArr;

    if (!this.isError) {
      this.rootNode = this.parseTreeNode({}, nodes);
    }else{
      errorText = i18n.get('SITE_MAP_ERROR');
      if(errorText){
        errorArr = util.Text.delimitText(errorText, util.Text.DM_RETURN);
      }
    }
    return (<div style={{
      fontSize : this.props.textSize,
      fontFamily : this.props.textFontFamily || decodeURIComponent(this.props.font.family),
      color : this.props.textColor,
      fontWeight : this.props.textStyles.fontWeight,
      fontStyle : this.props.textStyles.fontStyle,
      textDecoration : this.props.textStyles.textDecoration,
      height : '100%',
      width : '100%'
    }}>
      {
        this.isError &&
        (<div style={{width : '100%',height:'100%',textAlign:'center',border : '1px solid #444',backgroundColor : '#fff'}}>
          <div ref="err" style={{width:'100%',height : 'auto',whiteSpace:'nowrap',overflow:'hidden'}}>
            {
              errorArr && errorArr.map(function(err){
                return <div key="error">{err}</div>
              })
            }
          </div>
        </div>)
      }
      {
        !this.isError &&
        (<div style={{textDecoration : 'inherit'}}>
          {
            _nodes.map(function (node, index) {
              return (<Node key={index} {...node}/>)
            })
          }
          <canvas ref="link" style={{width:'100%',height:'100%'}} width={styleHelper.getWidth(this.props)} height={styleHelper.getHeight(this.props)}/>
        </div>)
      }
    </div>);
  },

  componentWillUnmount : function(){
    if(this.requestID){
      cancelAnimationFrame(this.requestID);
    }
  },

  componentDidMount: function () {
    var graphics;
    var self;
    var div;
    if (this.isError) {
      div = ReactDOM.findDOMNode(this.refs.err);
      $(div).css({'padding-top': (this.props.h - div.clientHeight) / 2 + 'px'});
      return;
    }
    self = this;
    this.requestID = window.requestAnimationFrame(function () {
      var canvas = ReactDOM.findDOMNode(self.refs.link);
      if(!canvas){
        return;
      }
      var graphics = canvas.getContext('2d');
      var ratio = graphicsHelper.applyDeviceRatio(graphics,styleHelper.getWidth(self.props),styleHelper.getHeight(self.props));
      graphics.beginPath();
      graphics.strokeStyle = '#444';
      graphics.strokeWidth = ratio;
      self.doPaintLine(self.rootNode, graphics,ratio);
    });
  },

  getNodeRect : function(node,ratio){
    var rect = {left:node.rect.left,top:node.rect.top,right:node.rect.right,bottom:node.rect.bottom};
    util.Rect.init(rect);
    util.Rect.scale(rect,ratio,ratio,false);
    return rect;
  },

  doPaintLine: function (node, graphics,ratio) {
    var rect = this.getNodeRect(node,ratio);// {left:node.rect.left,top:node.rect.top,width:node.rect.width,height:node.rect.height};
    var startPoint = {
      x: (rect.left + rect.right) / 2,
      y: rect.bottom
    };
    console.log(rect,graphics.canvas.width);
    var child = node.children;
    var crect;
    var i = 0;
    var cnode;
    var endPoint;
    var turnX;
    var turnY;
    var l = child.length;
    for (i; i < l; i++) {
      cnode = child[i];
      crect = this.getNodeRect(cnode,ratio);// cnode.rect;
      endPoint = {
        x: (crect.left + crect.right) / 2,
        y: crect.top
      };
      turnX = Math.round(startPoint.x) - graphics.strokeWidth / 2;
      turnY = Math.round(startPoint.y) - graphics.strokeWidth / 2;
      graphics.moveTo(turnX, turnY);
      if (endPoint.x === startPoint.x || l === 1) {
        turnX = Math.round(startPoint.x) - graphics.strokeWidth / 2;
        turnY = Math.round(endPoint.y) - graphics.strokeWidth / 2;
        graphics.lineTo(turnX, turnY);
      } else {
        //turnY = Math.round((startPoint.y + endPoint.y) / 2) - graphics.strokeWidth / 2;
        turnY = endPoint.y - 25 * ratio - graphics.strokeWidth / 2;
        graphics.lineTo(turnX, turnY);
        turnX = Math.round(endPoint.x) - graphics.strokeWidth / 2;
        graphics.lineTo(turnX, turnY);
        turnY = Math.round(endPoint.y) - graphics.strokeWidth / 2;
        graphics.lineTo(turnX, turnY);
      }
      graphics.stroke();
      if (cnode.children) {
        this.doPaintLine(cnode, graphics,ratio);
      }
    }
  }
});

module.exports = SiteMap;



// WEBPACK FOOTER //
// ./src/views/Components/SiteMap.jsx